export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-graph-trend-0cc329a7ff141387dc9aeddf3aa8a05e.svg";